var App = App || {};

App.WidgetFaqSimple = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            var component = selector;
            var faqsList = component.find(".faqs-list");
            var control = component.find(".widget-faqSimple-control > button");

            control.on("click", function () {
                var expanded = $(this).attr("aria-expanded") == "true";
                var panels = faqsList.find(".faq-item-more")
                if (!expanded) {
                    $(this).attr("aria-expanded", "true");
                    //panels.show();
                    panels.addClass("faq-item-conditional").removeClass("zag-d-none");
                }
                else {
                    $(this).attr("aria-expanded", "false");
                    //panels.hide();
                    panels.removeClass("faq-item-conditional").addClass("zag-d-none");
                }
            });

        }
    }

    return {
        Init: Init
    };

})(jQuery);